import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import ICountUp from 'vue-countup-v2'
import AOS from 'aos';
import 'aos/dist/aos.css';
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/dist/vuetify.js'
import VueApexCharts from 'vue-apexcharts'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueApexCharts)
Vue.use(VueExcelXlsx);
Vue.component('apexchart', VueApexCharts)

Vue.use(Vuetify)

Vue.config.productionTip = false
// new Vue({
// 	created(){
// 		AOS.init();
// 	}
// });

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
